import { Grid, TextField } from '@mui/material';
import { useState } from 'react';

export function Comment({ comment, saveComment }) {
  const [commentDraft, setCommentDraft] = useState(comment || '');

  const handleCommentChange = (val) => {
    setCommentDraft(val);
    saveComment(val);
  };

  return (
    <>
      <Grid item xs={12}>
        <TextField
          sx={{
            display: 'flex',
            width: '100%',
            margin: 'auto',
            textAlign: 'center',
          }}
          multiline
          rows={4}
          label="Comment"
          value={commentDraft}
          onChange={(event) => handleCommentChange(event.target.value)}
        />
      </Grid>
    </>
  );
}
